import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate } from "react-router-dom";
import { RouteName } from "constants/route";
import createPromoCodeValidator from "validators/createPromoCode.validator";
import { IPromoCodeInput } from "models/promoCode";
import { createPromoCodeApi } from "api/promoCode";

export default function useCreatePromoCode() {
  const navigate = useNavigate();
  const { showError, showSuccess } = useNotificationContext();
  const [loading, setLoading] = useState<boolean>(false);
  const { control, handleSubmit } = useForm<IPromoCodeInput>({
    resolver: yupResolver(createPromoCodeValidator),
  });

  const onSubmit = async (input: IPromoCodeInput) => {
    setLoading(true);
    const { data, error } = await createPromoCodeApi(input);
    if (data) {
      showSuccess("Promo code created Successfully");
      navigate(RouteName.PROMO_CODE, { replace: true });
    } else {
      showError(error!.message);
    }
    setLoading(false);
  };

  return { handleSubmit, onSubmit, control, loading };
}
